var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/HTMLBaseButton.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { HTMLBase } from "./HTMLBase.js";
var HTMLBaseButton = class extends HTMLBase {
};
HTMLBaseButton._class = "HTMLBaseButton";
__decorateClass([
  Field((type) => String)
], HTMLBaseButton.prototype, "href", 2);
__decorateClass([
  Field((type) => String)
], HTMLBaseButton.prototype, "target", 2);
__decorateClass([
  Field((type) => Boolean)
], HTMLBaseButton.prototype, "fullWidth", 2);
__decorateClass([
  Field((type) => String, { default: (v) => v ?? "action" })
], HTMLBaseButton.prototype, "mode", 2);
HTMLBaseButton = __decorateClass([
  Entity()
], HTMLBaseButton);
export {
  HTMLBaseButton
};
